import {useMutation, useQueryClient} from '@tanstack/react-query';
import {usersApi, fundsApi} from '../../../entities';
import {useNotifications} from '../../../shared';
import {EntityType} from './useAvatarUpload';

interface UseDeleteAvatarResult {
  deleteAvatar: () => void;
  isDeleting: boolean;
  error: Error | null;
}

export const useDeleteAvatar = (
  entityId: string,
  queryKey: string,
  entityType: EntityType = EntityType.USER,
): UseDeleteAvatarResult => {
  const queryClient = useQueryClient();
  const {createNotification} = useNotifications();

  const mutation = useMutation({
    mutationFn: () => {
      if (entityType === EntityType.USER) {
        return usersApi.deleteAvatar(entityId);
      } else if (entityType === EntityType.FUND) {
        return fundsApi.deleteFundAvatar(entityId);
      }
      throw new Error('Неподдерживаемый тип сущности');
    },
    onSuccess: () => {
      queryClient.invalidateQueries({queryKey: [queryKey, entityId]});
    },
    onError: () => {
      createNotification({
        name: 'avatar-delete-error',
        title: 'Ошибка при удалении аватара',
        theme: 'danger',
      });
    },
  });

  return {
    deleteAvatar: mutation.mutate,
    isDeleting: mutation.isPending,
    error: mutation.error,
  };
};
